import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ClientSessionService } from '@brighthub/uisession';
import { NotificationTarget } from './notification.model';

@Injectable({ providedIn: 'root' })
export class NotificationNavigationService {
  private readonly _router = inject(Router);
  private readonly _sessionService = inject(ClientSessionService);

  navigateTo(target: NotificationTarget): void {
    const clientIdentifier = target.subjectGuid ?? target.clientId;
    if (clientIdentifier) {
      this._sessionService.createOrSelectClientConversation(clientIdentifier);
    }

    const queryParams: Record<string, string> = {};
    if (target.tab) {
      queryParams['notifTab'] = target.tab;
    }

    this._router.navigate([target.route], {
      queryParams: Object.keys(queryParams).length > 0 ? queryParams : undefined,
    });
  }
}
